'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var COMMON_MESSAGE = exports.COMMON_MESSAGE = 'COMMON_MESSAGE';